import React, { useEffect } from 'react';
import { Select } from 'components/partials/Fields/FormikSelect';
import { Loading } from 'components/Loading';
import { useGlobalContext } from 'context/GlobalContext';

interface CountrySelectProps {
    label?: string;
    name?: string;
    stateField?: boolean | string;
    nested?: boolean;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
    label = 'Country',
    name = 'country_id',
    stateField = false,
    ...props
}) => {
    const { countries, countriesLoading, getCountries } = useGlobalContext();

    useEffect(() => {
        if (countries.length === 0) getCountries();
    }, []);

    return (
        <>
            {countriesLoading ? <Loading/> : (
                <Select
                    formik
                    name={name}
                    label={label}
                    addBlank
                    loading={countriesLoading}
                    {...props}
                >
                    {(countries || []).map(({ country_id, country_name }) => (
                        <option key={country_id} value={country_id}>
                            {country_name}
                        </option>
                    ))}
                </Select>
            )}
        </>
    );
};
